import React, { useState } from "react";  
import { useLocation } from "react-router-dom";  
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import ButtonsSection from '../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection';  
import NoteTable from '../../common_nextgen/common_components/NoteScreenComponents/NoteTable';  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import useBenefitMaxScheduleNotes from "./hooks/useBenefitMaxScheduleNotes";  
import { PRICE_SCHEDULE_MODES, ROUTE_PATHS } from '../../common_nextgen/utils/Constants';
  
const BenefitMaxScheduleNote = () => {  
  const location = useLocation(); 
  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
const previousState = [...stateVal];
previousState.splice(stateVal.length - 1, 1);

  let {
      selectedPriceSchedules = [],
      previousScreen = ROUTE_PATHS.BENEFIT_MAX_SCHEDULE,
      currentIndex: initialIndex = 0,
      currentMode
    } = currentState; 
  // const { selectedPriceSchedules, currentMode, currentIndex: initialIndex = 0,description } = location.state || {};  
  const navigateToPage = useCustomNavigate();  
  
  const {  
    notes,  
    newNotes,  
    mode,  
    first,  
    rows,  
    totalRecords,  
    currentIndex,  
    setMode,  
    setFirst,  
    setRows,  
    setCurrentIndex,  
    handleSaveNotes,  
    handleChangeNewNote,  
    onPageChange,  
    exportAsCSV  
  } = useBenefitMaxScheduleNotes(selectedPriceSchedules, initialIndex, currentMode);  
  
  const screen_title = "Benefit Max Schedule Note";  
  const screen_code = "RCBSN001";  
  
  const columns = mode === 'view'  
    ? [  
        { key: 'bsnNote', header: 'Note' },  
        { key: "chgDate", header: "Added Date" },
        { key: "chgTime", header: "Added Time" }, 
        { key: 'chgUserName', header: 'User' }  
      ]  
    : [  
        { key: 'bsnNote', header: 'Note' }  
      ];  
  
  const handleBack = () => {  
    if (currentMode === 'edit') {  
      navigateToPage("/edit-benefit-max-schedule", { selectedPriceSchedules, currentIndex });  
    } else if (currentMode === 'disp') {  
      navigateToPage("/display-benefit-max-schedule", { selectedPriceSchedules, currentIndex });  
    } else {  
      if (currentIndex < selectedPriceSchedules.length - 1) {  
        setCurrentIndex(currentIndex + 1);  
      } else {  
        navigateToPage(previousScreen,previousState
        );  
      }  
    }  
  };  
  
  const handleBackAndSetMode = () => {  
    handleBack();  
    setMode("view");  
  };  
  
  function handleModeSwitch() {  
    if (mode === "add") {  
      setMode("view");  
    } else if (mode === "view") {  
      setMode("add");  
    }  
  }  
  
  const leftButtons = [  
        { button_label: 'Back', button_handeler: handleBackAndSetMode, button_key: 'F12' },  
        ...(mode === 'add' ? [{ button_label: 'View Note', button_handeler: handleModeSwitch, button_key: 'F9' }] : []),  
  ];  
  
  const rightButtons = [  
    ...(mode === 'view' ? [{ button_label: 'Add Note', button_handeler: handleModeSwitch, button_key: 'F9' }] : []),  
    { button_label: 'Export as CSV', button_handeler: exportAsCSV }  
  ];  
  
  const [paramsData, setParamsData] = useState({  
    bscScheduleName: selectedPriceSchedules[currentIndex].bscScheduleName  
  });  
  
  const getName = (selectedPriceSchedules, currentIndex) => (  
    <>  
      <span className="info-records">  
        <strong>Schedule </strong>  
        {selectedPriceSchedules[currentIndex].bscScheduleName}  
      </span>  
      <span className="info-records">  
        <strong>Description </strong>  
        {selectedPriceSchedules[currentIndex].bscDescription} 
      </span>  
    </>  
  );  
  
  return (  
    <div className="container">  
      <ButtonsSection ctaButtons={leftButtons} align="left" />  
      <div className="left-aligned-section">  
        <div className="header-section">  
          <h1>  
            {screen_title} - <span className="heading-cod">{screen_code}</span>  
          </h1>  
        </div>  
        <p className="head-name">{getName(selectedPriceSchedules, currentIndex)}</p>  
      </div>  
      <div className="button-sections">  
        <ButtonsSection ctaButtons={rightButtons} align="right" />  
      </div>  
      <NoteTable  
        data={notes}  
        columns={columns}  
        mode={mode}  
        newNotes={newNotes}  
        handleChangeNewNote={handleChangeNewNote}  
        handleSaveNotes={handleSaveNotes}  
      />  
      <NextGenPaginator  
        first={first}  
        rows={rows}  
        totalRecords={totalRecords}  
        currentPage={first / rows}  
        rowsPerPageOptions={[10, 25, 50]}  
        onPageChange={onPageChange}  
      />  
    </div>  
  );  
};  
  
export default BenefitMaxScheduleNote; 